<div class="modal-body">
    <button type="button" class="close" (click)="dismiss()">
        <span aria-hidden="true"><i class="icon-close"></i></span>
    </button>
    <br><br>
    <div [innerHTML]="data.message"></div>
</div>